import BetsSettingsPartContainerPortrait from "@baseUI/component/settings/BetsSettingsPartContainerPortrait";
import UIFacade from "@baseUI/UIFacade";
import UIConfig from "@baseUI/config/UIConfig";
import InfoSettingsPartContainerLandscape from "@baseUI/component/settings/InfoSettingsPartContainerLandscape";
import MenuPopupLayout from "@baseUI/component/layout/MenuPopupLayout";
import AutospinSettingsPartContainerLandscape from "@baseUI/component/settings/AutospinSettingsPartContainerLandscape";
import SettingsSettingsPartContainerLandscape from "@baseUI/component/settings/SettingsSettingsPartContainerLandscape";
import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import BetsSettingsPartContainerLandscape from "@baseUI/component/settings/BetsSettingsPartContainerLandscape";

export default class MenuPopupLayoutLandscape extends MenuPopupLayout {

    constructor() {
        super()
    }

    setParametersSizePosition(){
        this.param = {
            shadowRect: { x: -UIConfig.totalWidth / 2, y: 0, width : UIConfig.totalWidth, height: UIConfig.totalHeight},
            panelPopupPosition: {x: -UIConfig.totalWidth / 2 + 300, y: 250 },
            closeBtnPosition: {x: 2000, y: 550},
            panelBtnPosition: {x: 0, y: 200},
            listButtonsPosition: {ax: 0, bx: 0, ay: 100, by:120},
            panelAdditionalPosition:{x: 500, y: 200}
        }

        this.paramPageCommon = {
            captionPosition: [560, 0]
        }
    }

    createCloseButton(panelPopup) {
        const closeBtnHitArea = new PIXI.Rectangle(-80,-80, 160, 160);
        this.closeBtn = UICreatorComponent.addButtonHitArea('settingClose_BUTTON', panelPopup, this.param.closeBtnPosition, closeBtnHitArea);
        this.closeBtn.on('tapButton', () => {
            this.hide()
            this.hideAllPart()
        })
    }

    createButtons(panelPopup){

        super.createButtons(panelPopup)
        UICreatorGraphics.addLine(panelPopup, 150,500,150,1500)
    }

    createImplementationMenu(panelPopup){
        const panelAdditional = UICreatorComponent.addContainer(panelPopup, this.param.panelAdditionalPosition)

        this.betPopup = new BetsSettingsPartContainerLandscape(this.paramPageCommon)
        panelAdditional.addChild(this.betPopup)
        this.betPopup.visible = true

        this.autospinPopup = new AutospinSettingsPartContainerLandscape(this.paramPageCommon)
        panelAdditional.addChild(this.autospinPopup)
        this.autospinPopup.visible = false

        this.infoPopup = new InfoSettingsPartContainerLandscape()
        panelAdditional.addChild(this.infoPopup)
        this.infoPopup.visible = false

        this.settingsPopup = new SettingsSettingsPartContainerLandscape(this.paramPageCommon)
        panelAdditional.addChild(this.settingsPopup)
        this.settingsPopup.visible = false

        this.panelAdditional = panelAdditional
    }

    updateSize(uiModelView){
        if(this.panelBtn && this.panelAdditional){
            this.panelBtn.y = -50 - uiModelView.shiftY
            this.panelAdditional.y = -130 - uiModelView.shiftY
        }

    }
}
